var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex center-xs space-top-1 space-bottom-2" }, [
        _c("div", { staticClass: "vertical-center input-container" }, [
          _c("div", { staticClass: "start-xs full-width" }, [
            _c("label", { attrs: { for: _vm.step.name } }, [
              _vm._v(_vm._s(_vm.step.label)),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.inputData,
                  expression: "inputData",
                  modifiers: { trim: true },
                },
                { name: "focus", rawName: "v-focus" },
              ],
              ref: "textInput",
              staticClass: "full-width",
              attrs: { type: "text", placeholder: _vm.step.placeholder },
              domProps: { value: _vm.inputData },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.keycheck.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.inputData = $event.target.value.trim()
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _vm.inputValid
              ? _c("div", { staticClass: "valid-check" })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "full-width" }, [
            _vm.displayErrorMessage
              ? _c("div", { staticClass: "red-text space-top-2" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.step.errorMessage) +
                      "\n                "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("ButtonSection", {
        attrs: {
          inputValid: _vm.inputValid,
          order: _vm.order,
          buttonText: _vm.step.buttonText,
        },
        on: {
          progress: _vm.handleProgress,
          back: function ($event) {
            return _vm.$emit("back")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }